export const paymentMethods = [
  "creditCard",
  "Pay At Hotel",
  "braintree",
  "paypal",
  "vnpay",
  "onepay",
];
